module.exports = __webpack_public_path__ + "img/bunq.139cf12c.svg";